export default "__VITE_ASSET__diKz5gNS__"